import { useCallback } from 'react';
import { add as addDuration, sub as subDuration } from 'date-fns';

import { ChevronLeftIcon, ChevronRightIcon } from 'app/agriculture/icons';
import {
    useTimelineInterval,
    useTimelineDispatch,
    useTimelineViewMode,
} from 'app/agriculture/AgTimeline/context/TimelineContext';

import './TimelineBumper.scss';

export function TimelineBumper({ direction }: { direction: 'left' | 'right' }) {
    const timelineInterval = useTimelineInterval();
    const { bumpDuration } = useTimelineViewMode();
    const { setInterval } = useTimelineDispatch();

    const handleLeft = useCallback(() => {
        setInterval({
            start: subDuration(timelineInterval.start, bumpDuration),
            end: subDuration(timelineInterval.end, bumpDuration),
        });
    }, [bumpDuration, setInterval, timelineInterval]);

    const handleRight = useCallback(() => {
        setInterval({
            start: addDuration(timelineInterval.start, bumpDuration),
            end: addDuration(timelineInterval.end, bumpDuration),
        });
    }, [bumpDuration, setInterval, timelineInterval]);

    switch (direction) {
        case 'left':
            return (
                <button
                    title="bump left"
                    className="TimelineBumper TimelineBumper--left"
                    data-testid="TimelineBumper"
                    onClick={handleLeft}
                >
                    <ChevronLeftIcon size={22} />
                </button>
            );
        case 'right':
            return (
                <button
                    title="bump right"
                    className="TimelineBumper TimelineBumper--right"
                    data-testid="TimelineBumper"
                    onClick={handleRight}
                >
                    <ChevronRightIcon size={22} />
                </button>
            );
    }
}
